import BackOfficeDashboardWorkspace from '../../placeholders/BackOfficeDashboardWorkspace';

export default BackOfficeDashboardWorkspace;
